import {
    GET_BANNERS_SUCCESS, GET_BANNERS_LOADING, GET_BANNERS_ERROR,
    ADD_BANNER_SUCCESS, ADD_BANNER_LOADING, ADD_BANNER_ERROR,
    UPDATE_BANNER_SUCCESS, UPDATE_BANNER_LOADING, UPDATE_BANNER_ERROR,
    DELETE_BANNER_SUCCESS, DELETE_BANNER_LOADING, DELETE_BANNER_ERROR,
    GET_HERO_BANNER_ELIGIBLE_SERIES_SUCCESS, GET_HERO_BANNER_ELIGIBLE_SERIES_LOADING, GET_HERO_BANNER_ELIGIBLE_SERIES_ERROR,
    UPDATE_HERO_BANNER_ELIGIBILITY_SUCCESS, UPDATE_HERO_BANNER_ELIGIBILITY_LOADING, UPDATE_HERO_BANNER_ELIGIBILITY_ERROR,
    REORDER_BANNERS_SUCCESS, REORDER_BANNERS_LOADING, REORDER_BANNERS_ERROR,
    GET_BANNERS_WITH_SERIES_SUCCESS, GET_BANNERS_WITH_SERIES_LOADING, GET_BANNERS_WITH_SERIES_ERROR,
    UPLOAD_BANNER_IMAGE_SUCCESS, UPLOAD_BANNER_IMAGE_LOADING, UPLOAD_BANNER_IMAGE_ERROR
} from "../Type";
import * as Authservices from "../../Services/services";

export const getBanners = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: GET_BANNERS_LOADING, data: true });
        Authservices.getBanners(data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: GET_BANNERS_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: GET_BANNERS_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const createBanner = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: ADD_BANNER_LOADING, data: true });
        Authservices.createBanner(data)
            .then((res) => {
                if (res?.status === 201 || res?.status === 200) {
                    dispatch({ type: ADD_BANNER_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: ADD_BANNER_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const updateBanner = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: UPDATE_BANNER_LOADING, data: true });
        Authservices.updateBanner(id, data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: UPDATE_BANNER_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: UPDATE_BANNER_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const patchBanner = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: UPDATE_BANNER_LOADING, data: true });
        Authservices.patchBanner(id, data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: UPDATE_BANNER_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: UPDATE_BANNER_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const deleteBanner = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: DELETE_BANNER_LOADING, data: true });
        Authservices.deleteBanner(id)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: DELETE_BANNER_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: DELETE_BANNER_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const getHeroBannerEligibleSeries = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: GET_HERO_BANNER_ELIGIBLE_SERIES_LOADING, data: true });
        Authservices.getHeroBannerEligibleSeries(data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: GET_HERO_BANNER_ELIGIBLE_SERIES_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: GET_HERO_BANNER_ELIGIBLE_SERIES_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const updateHeroBannerEligible = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: UPDATE_HERO_BANNER_ELIGIBILITY_LOADING, data: true });
        Authservices.updateHeroBannerEligible(data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: UPDATE_HERO_BANNER_ELIGIBILITY_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: UPDATE_HERO_BANNER_ELIGIBILITY_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const reorderBanners = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: REORDER_BANNERS_LOADING, data: true });
        Authservices.reorderBanners(data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: REORDER_BANNERS_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: REORDER_BANNERS_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const getBannersWithSeries = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: GET_BANNERS_WITH_SERIES_LOADING, data: true });
        Authservices.getBannersWithSeries(data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: GET_BANNERS_WITH_SERIES_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: GET_BANNERS_WITH_SERIES_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const uploadBannerImage = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: UPLOAD_BANNER_IMAGE_LOADING, data: true });
        Authservices.uploadBannerImage(data)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch({ type: UPLOAD_BANNER_IMAGE_SUCCESS, data: res.data });
                    resolve(res.data);
                }
            })
            .catch((err) => {
                dispatch({ type: UPLOAD_BANNER_IMAGE_ERROR, data: err?.response?.data?.responseMessage });
                reject(err?.response?.data);
            });
    });
};

export const searchSeriesForBanner = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        Authservices.searchSeriesForBanner(data)
            .then((res) => {
                if (res?.status === 200) {
                    resolve(res.data);
                }
            })
            .catch((err) => {
                reject(err?.response?.data);
            });
    });
};

export const uploadBannerVideo = (file, onProgress) => async () => {
    const response = await Authservices.getBannerPresignedUrl({
        filename: file.name, content_type: 'video/mp4',
    });
    const { upload_url, s3_key } = response.data?.data || {};
    if (!upload_url || !s3_key) throw new Error('Could not prepare the banner video upload');
    await Authservices.s3Axios.put(upload_url, file, {
        headers: { 'Content-Type': 'video/mp4' },
        onUploadProgress: event => {
            if (event.total) onProgress(Math.round(event.loaded * 100 / event.total));
        },
    });
    return s3_key;
};
